import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ead2dc6c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead2dc6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ead2dc6c')) {
      api.createRecord('ead2dc6c', component.options)
    } else {
      api.reload('ead2dc6c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ead2dc6c&scoped=true&", function () {
      api.rerender('ead2dc6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JeUg70LP9J7A/JS/comp/Accordion.vue"
export default component.exports